import { useFilterPanelContext } from '../../context/FilterPanelContext';
import style from '../../FilterPanel.module.scss';
import { Preset } from '../../types';
import PresetButton from './components/PresetButton/PresetButton';

const SavedFilters = () => {
  const { presets } = useFilterPanelContext();

  if (presets?.length <= 0) return null;

  return (
    <div className={style.savedFiltersRow}>
      {presets?.map((f: Preset) => (
        <PresetButton f={f} />
      ))}
    </div>
  );
};

export default SavedFilters;
